<template lang="pug">
    .row
        .root-wrapper
            home-slide
            search-professional
            // what-we-do
            last-news
            //press-note
            // home-trainers
            home-boxes
            facebook-group
            // social-media
</template>

<script>
import HomeSlide from './HomeSlide'
import PressNote from './press_note/PressNote'
import WhatWeDo from './whatwedo/WhatWeDo'
import LastNews from './lastnews/LastNews'
import HomeTrainers from './home_trainers/HomeTrainers'
import HomeBoxes from './home_boxes/HomeBoxes'
import FacebookGroup from './facebook-group/FacebookGroup'
import SearchProfessional from './search_professional/SearchProfessional'
import SocialMedia from './social_media/SocialMedia'

export default {
  name: 'Root',
  components: {
    HomeBoxes,
    HomeSlide,
    HomeTrainers,
    FacebookGroup,
    WhatWeDo,
    LastNews,
    PressNote,
    SearchProfessional,
    SocialMedia,
  },
  head: {
    title: {
      inner: 'Inicio',
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
@import './../variables';

.root-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Root.vue